import React, {useEffect, useRef, useState} from "react";
import "./table.css";
import {showCatchError, toEnglishNumbers} from "../../helpers/Utils";
import Excel from "./excel";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import FormControl from "@mui/material/FormControl";
import axios from "../../containers/api";
import {Pagination, PaginationItem, PaginationLink, UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle, Button, Label, Input, FormGroup} from "reactstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const Table = ({tableHeaders, tableRow, tableData, tableFieldsProp, showAlert, showSpinner, hideSpinner, closeSweetAlert, showSweetAlert, reportType}) => {

    const [tableSearchValue, setTableSearchValue] = useState("");
    const [tableRowCount, setTableRowCount] = useState(10);
    const [pageNumbers, setPageNumbers] = useState([]);
    const [selectedPage, setSelectedPage] = useState(0);
    const [from, setFrom] = useState(tableRowCount);
    const [to, setTo] = useState(1);
    const [searchedTableRow, setSearchedTableRow] = useState([]);
    const myTableBody = useRef(null);
    const myTable = useRef();
    const [tableColumns, setTableColumns] = useState(tableHeaders);
    const [tableColumnsIndex, setTableColumnsIndex] = useState([]);
    const [memberReports, setMemberReports] = useState([]);
    const [memberReport, setMemberReport] = useState(null);
    const [createReport, setCreateReport] = useState(false);
    const [reportName, setReportName] = useState(null);
    const [reportCols, setReportCols] = useState([]);
    const [reportColsName, setReportColsName] = useState([]);

    useEffect(() => {
        let arr2 = [];
        tableRow.map((item) =>
            JSON.stringify(item).includes(tableSearchValue) ? arr2.push(item) : null
        );
        setSearchedTableRow(arr2);

        let arr = [];
        for (let i = 0; i < arr2.length / tableRowCount; i++) {
            arr.push(i + 1)
        }
        setPageNumbers(arr);
        if (tableRowCount === 1000000) {
            setFrom(0);
            setTo(arr2.length)
        } else {
            setFrom(tableRowCount * (selectedPage+1) - tableRowCount);
            setTo(tableRowCount * (selectedPage+1))
        }

    }, [tableRow, tableRowCount, selectedPage, tableSearchValue]);

    useEffect(() => {
        if (tableFieldsProp != null) {
            getMemberReports();
        }
    }, []);

    const sortTable = (n) => {
        let table, rows, switching, i, x, y, shouldSwitch, dir, switchCount = 0;
        table = myTableBody.current;
        switching = true;

        dir = "asc";
        while (switching) {
            switching = false;
            rows = table.rows;
            for (i = 0; i < (rows.length - 1); i++) {
                shouldSwitch = false;
                x = rows[i].getElementsByTagName("TD")[n];
                y = rows[i + 1].getElementsByTagName("TD")[n];

                if (dir === "asc") {

                    if (/\d/.test(toEnglishNumbers(x.innerHTML))) {
                        //if (parseInt(toEnglishNumbers(x.innerHTML)) > parseInt(toEnglishNumbers(y.innerHTML.toLowerCase()))) {
                        if (parseInt(toEnglishNumbers(x.innerHTML.split("/").pop())) > parseInt(toEnglishNumbers(y.innerHTML.split("/").pop()))) {
                            shouldSwitch = true;
                            break;
                        }
                    } else {
                        if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                            shouldSwitch = true;
                            break;
                        }
                    }


                } else if (dir === "desc") {
                    if (/\d/.test(toEnglishNumbers(x.innerHTML))) {
                        //if (parseInt(toEnglishNumbers(x.innerHTML)) < parseInt(toEnglishNumbers(y.innerHTML))) {
                        if (parseInt(toEnglishNumbers(x.innerHTML.split("/").pop())) < parseInt(toEnglishNumbers(y.innerHTML.split("/").pop()))) {
                            shouldSwitch = true;
                            break;
                        }
                    } else {
                        if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                            shouldSwitch = true;
                            break;
                        }
                    }
                }
            }
            if (shouldSwitch) {
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                switchCount++;

            } else {
                if (switchCount === 0 && dir === "asc") {
                    dir = "desc";
                    switching = true;
                }
            }
        }
    };

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setTableColumns(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const getMemberReports = (created = false) => {
        axios.get('api/reportApi/GetReportBymemberId?ReportType='+reportType)
            .then((res) => {
                if (res.data == "موردی یافت نشد") {
                    setMemberReports([]);
                } else {
                    setMemberReports(res.data);
                }

                if (created) {
                    closeCreateReport();
                }
            })
            .catch((error) => {
                console.log(error.response);
                showAlert(showCatchError(error), "error");
            });
    }
    const handleNewReportColsChange = (event) => {
        const {
            target: { value },
        } = event;
        setReportColsName(
            typeof value === 'string' ? value.split(',') : value,
        );
    }
    const handleAddReportCols = (index) => {
        let newCol = tableFieldsProp[index];
        let newColIndex = reportCols.indexOf(newCol);
        let tempArr = reportCols;

        if (newColIndex > -1) {
            tempArr.splice(newColIndex, 1);
        } else {
            tempArr.push(newCol);
        }

        setReportCols(tempArr);
    }
    const createNewReport = () => {
        if (reportName === null || reportName == "" || reportName == " ") {
            showAlert("لطفا نام گزارش را وارد کنید.", "error");
        } else {
            let fields = [];
            for (let i = 0; i < reportCols.length; i++) {
                let newField = {
                    "LatinName": reportCols[i].field,
                    "FarsiName": reportCols[i].title
                }
                fields.push(newField);
            }

            let postData = {
                "Name": toEnglishNumbers(reportName),
                "ReportName": reportType,
                "ReportId": null,
                "ColumnList": fields
            }

            showSpinner();
            axios.post('api/reportApi/SaveReport', postData)
                .then((res) => {
                    hideSpinner();
                    showAlert('گزارش جدید با موفقیت اضافه شد', 'success');
                    getMemberReports(true);
                })
                .catch((error) => {
                    hideSpinner();
                    console.log(error.response);
                    showAlert(showCatchError(error), "error");
                });
        }
    }
    const handleSelectMemberReport = (e, report, name) => {
        setMemberReport(report);
        let reportCols = report.farsiColumnName;
        let tempArr = [];
        for (let i = 0; i < tableHeaders.length; i++) {
            if (reportCols.indexOf(tableHeaders[i]) === -1) {
                tempArr.push(i);
            }
        }
        setTableColumnsIndex(tempArr);
        setTableColumns(reportCols);
    };
    const closeCreateReport = () => {
        setReportName(null);
        setReportCols([]);
        setCreateReport(false);
    }
    const handleIndexChangeColumns = (index) => {
        let tempArr = tableColumnsIndex;
        let iIndex = tableColumnsIndex.indexOf(index);

        if (iIndex > -1) {
            tempArr.splice(iIndex, 1);
        } else {
            tempArr.push(index);
        }

        setTableColumnsIndex(tempArr);
    };

    // const exportTable = () => {
    //     $("table").tableExport({
    //         headers: true,                              // (Boolean), display table headers (th or td elements) in the <thead>, (default: true)
    //         footers: true,                              // (Boolean), display table footers (th or td elements) in the <tfoot>, (default: false)
    //         formats: ['xlsx'],            // (String[]), filetype(s) for the export, (default: ['xlsx', 'csv', 'txt'])
    //         filename: 'my table',                             // (id, String), filename for the downloaded file, (default: 'id')
    //         bootstrap: false,                           // (Boolean), style buttons using bootstrap, (default: true)
    //         exportButtons: true,                        // (Boolean), automatically generate the built-in export buttons for each of the specified formats (default: true)
    //         position: 'bottom',                         // (top, bottom), position of the caption element relative to table, (default: 'bottom')
    //         ignoreRows: null,                           // (Number, Number[]), row indices to exclude from the exported file(s) (default: null)
    //         ignoreCols: null,                           // (Number, Number[]), column indices to exclude from the exported file(s) (default: null)
    //         trimWhitespace: false,                       // (Boolean), remove all leading/trailing newlines, spaces, and tabs from cell text in the exported file(s) (default: false)
    //         RTL: true,                                 // (Boolean), set direction of the worksheet to right-to-left (default: false)
    //         sheetname: "نام"                             // (id, String), sheet name for the exported spreadsheet, (default: 'id')
    //     });
    //     document.getElementsByClassName("xlsx")[0].style.display = 'none';
    //     document.getElementsByClassName("xlsx")[0].click();
    // };

    const renderPages = () => {
        let pageButtons = [];

        if (pageNumbers.length > 5) {
            if (selectedPage > 2) {
                if (selectedPage+2 < pageNumbers.length) {
                    for (let i = selectedPage-2; i <= selectedPage+2; i++) {
                        let active = selectedPage === i;
                        pageButtons.push(
                            <PaginationItem key={i} active={active}>
                                <PaginationLink onClick={() => changePage(i)}>{i+1}</PaginationLink>
                            </PaginationItem>
                        );
                    }
                } else {
                    for (let i = selectedPage-4; i < pageNumbers.length; i++) {
                        let active = selectedPage === i;
                        pageButtons.push(
                            <PaginationItem key={i} active={active}>
                                <PaginationLink onClick={() => changePage(i)}>{i+1}</PaginationLink>
                            </PaginationItem>
                        );
                    }
                }
            } else {
                for (let i = 0; i < 5; i++) {
                    let active = selectedPage === i;
                    pageButtons.push(
                        <PaginationItem key={i} active={active}>
                            <PaginationLink onClick={() => changePage(i)}>{i+1}</PaginationLink>
                        </PaginationItem>
                    );
                }
            }
        } else {
            for (let i = 0; i < pageNumbers.length; i++) {
                let active = selectedPage === i;
                pageButtons.push(
                    <PaginationItem key={i} active={active}>
                        <PaginationLink onClick={() => changePage(i)}>{i+1}</PaginationLink>
                    </PaginationItem>
                );
            }
        }

        return pageButtons;
    }
    const changePage = (i) => {
        if (i === "prev") {
            if (selectedPage !== 0) {
                setSelectedPage(selectedPage - 1)
            }
        } else if (i === "next") {
            if (selectedPage !== pageNumbers.length-1) {
                setSelectedPage(selectedPage + 1)
            }
        } else if (i === "first") {
            setSelectedPage(0)
        } else if (i === "last") {
            setSelectedPage(pageNumbers.length-1)
        } else {
            setSelectedPage(i)
        }
    }

    const changePageSize = (size) => {
        setTableRowCount(size);
        setSelectedPage(1);
    }

    const deleteReport = (id) => {
        closeSweetAlert();
        axios.post('api/reportApi/DeleteReport?reportid='+id)
            .then((res) => {
                showAlert('گزارش مورد نظر با موفقيت حذف گرديد', 'success');
                getMemberReports();
            })
            .catch((error) => {
                showAlert('خطا در حذف گزارش', 'error');
            });
    }

    return (
        <div className="table mt-3 mb-3">
            <div className="table-header">
                <div className="table-options align-items-end mb-4 mt-3">
                    {createReport ?
                        <>
                            <FormGroup className="w-md-30 w-100 px-1 d-flex flex-column align-items-center reportName">
                                <Label>نام گزارش</Label>
                                <Input value={reportName} onChange={(e) => setReportName(e.target.value)}/>
                            </FormGroup>

                            <div className="table-options-rows">
                                <FormControl size={'small'} sx={{ m: 1, width: 300 }}>
                                    <label className="form-title">انتخاب ستون‌های گزارش</label>
                                    <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        multiple
                                        value={reportColsName}
                                        onChange={handleNewReportColsChange}
                                        input={<OutlinedInput label="انتخاب ستون‌های گزارش"/>}
                                        renderValue={(selected) => selected.join(', ')}
                                        MenuProps={MenuProps}
                                    >
                                        {tableFieldsProp.map((tableField, index) => (
                                            <MenuItem onClick={() => handleAddReportCols(index)} key={tableField.field} value={tableField.title}>
                                                <Checkbox checked={reportCols.indexOf(tableField) > -1} />
                                                <ListItemText primary={tableField.title} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </>
                        :
                        <>
                            <div className="table-options-rows"/>

                            {memberReports != null && memberReports.length > 0 ?
                                <FormGroup className="w-md-20 w-100 px-1">
                                    <Label>گزارش‌های اختصاصی کاربر</Label>
                                    <Autocomplete
                                        clearText={"حذف"}
                                        closeText={"بستن"}
                                        noOptionsText={"در حال دریافت اطلاعات.."}
                                        openText={"باز کردن"}
                                        className="react-select__control"
                                        id="memberReport"
                                        options={memberReports}
                                        getOptionLabel={(option) => option.farsiReportName}
                                        value={memberReport}
                                        onChange={(e, v) => handleSelectMemberReport(e, v, "memberReport")}
                                        renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <span className="d-flex justify-content-between align-items-center w-100">
                                                    {option.farsiReportName}
                                                    <Button
                                                        className="deleteInAutoComplete"
                                                        outline color="danger" size="sm"
                                                        onClick={() => showSweetAlert("آیا از حذف این گزارش مطمئن هستید؟", "", "danger", () => deleteReport(option.id))}
                                                    >
                                                    <i className="fa fa-trash" aria-hidden="true"/>
                                                </Button>
                                                </span>
                                            </li>
                                        )}
                                    />
                                </FormGroup>
                                :
                                <div className="table-options-rows"/>
                            }
                        </>
                    }

                    {tableFieldsProp ?
                        <div className="table-options-rows">
                            {createReport ?
                                <>
                                    <Button color="success" className="mx-1" onClick={() => createNewReport()}>تایید</Button>
                                    <Button color="danger" className="mx-1" onClick={() => closeCreateReport()}>انصراف</Button>
                                </>
                                :
                                <Button color="primary" outline onClick={() => setCreateReport(true)}>ایجاد گزارش جدید از جدول</Button>
                            }
                        </div>
                        :
                        <div className="table-options-rows"/>
                    }
                </div>

                <div className="row">
                    <div className="col-md-4 d-flex col-12 justify-content-center align-items-center" id="displayOptions">
                        {myTable.current !== undefined && <Excel
                            id="test-table-xls-button"
                            className="btn btn-outline-primary btn-sm"
                            table={myTable.current}
                            filename="tablexls"
                            sheet="tablexls"
                            buttonText="چاپ گزارش‌ها"
                        />
                        }
                        {/* <button className="btn" type="button" onClick={() => exportTable()}>xlsx</button> */}
                    </div>

                    <div className="col-md-4 col-12 d-flex justify-content-center align-items-end"/>

                    <div className="col-md-4 d-flex col-12 justify-content-center align-items-center" id="displayOptions">
                        <FormControl size={'small'} sx={{ m: 1, width: 300 }}>
                            <label className="form-title">انتخاب ستون‌های جدول</label>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={tableColumns}
                                onChange={handleChange}
                                input={<OutlinedInput label="انتخاب ستون‌های جدول"/>}
                                // renderValue={(selected) => selected.join(', ')}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                                {tableHeaders.map((tableHeader, index) => (
                                    <MenuItem onClick={() => handleIndexChangeColumns(index)} key={tableHeader} value={tableHeader}>
                                        <Checkbox checked={tableColumns.indexOf(tableHeader) > -1} />
                                        <ListItemText primary={tableHeader} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 d-flex col-12 justify-content-center align-items-center order-0" id="displayOptions">
                        <div className="search-sm d-inline-block mr-1 mb-1">
                            <input
                                autoComplete="off"
                                type="text"
                                name="keyword"
                                id="search"
                                placeholder="جست‌وجو در جدول"
                                onKeyPress={(e) => setTableSearchValue(toEnglishNumbers(e.target.value))}
                            />
                        </div>
                    </div>

                    <div className="col-md-4 col-12 d-flex flex-column justify-content-center align-items-center order-md-1 order-2">
                        <span>نمایش {from === 0 ? "۱" : from} تا {to > searchedTableRow.length ? searchedTableRow.length : to} از {searchedTableRow.length}</span>

                        {tableRowCount !== 1000000 ?
                            <Pagination className="d-inline-block" size="sm" listClassName="justify-content-center" aria-label="Page navigation example">
                                <PaginationItem className={`${selectedPage===0 && "disabled"}`}>
                                    <PaginationLink
                                        className={"prev"}
                                        onClick={() => { changePage("first") }}
                                        disabled={selectedPage===0}>
                                        اولین
                                    </PaginationLink>
                                </PaginationItem>
                                <PaginationItem className={`${selectedPage===0 && "disabled"}`}>
                                    <PaginationLink
                                        className={"prev"}
                                        onClick={() => { changePage("prev") }}
                                        disabled={selectedPage===0}>
                                        <i className="simple-icon-arrow-left" />
                                    </PaginationLink>
                                </PaginationItem>

                                {renderPages()}

                                <PaginationItem className={`${selectedPage===pageNumbers.length-1 && "disabled"}`}>
                                    <PaginationLink
                                        className="next"
                                        onClick={() => { changePage("next") }}
                                        disabled={selectedPage===pageNumbers.length-1}>
                                        <i className="simple-icon-arrow-right" />
                                    </PaginationLink>
                                </PaginationItem>
                                <PaginationItem className={`${selectedPage===pageNumbers.length-1 && "disabled"}`}>
                                    <PaginationLink
                                        className="next"
                                        onClick={() => { changePage("last") }}
                                        disabled={selectedPage===pageNumbers.length-1}>
                                        آخرین
                                    </PaginationLink>
                                </PaginationItem>
                            </Pagination>
                            :
                            <Pagination className="d-inline-block" size="sm" listClassName="justify-content-center" aria-label="Page navigation example">
                                <PaginationItem active={true}>
                                    <PaginationLink>
                                        ۱
                                    </PaginationLink>
                                </PaginationItem>
                            </Pagination>
                        }
                    </div>

                    <div className="col-md-4 d-flex col-12 justify-content-center align-items-center order-md-2 order-1 my-md-0 my-2" id="displayOptions">
                        <div className="mr-1">
                            تعداد سطر:
                        </div>
                        <UncontrolledDropdown className="d-inline-block dropdown">
                            <DropdownToggle caret color="outline-dark" size="xs">
                                {tableRowCount !== 1000000 ? tableRowCount : "همه"}
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem key={1} onClick={() => changePageSize(5)}>۵</DropdownItem>
                                <DropdownItem key={2} onClick={() => changePageSize(10)}>۱۰</DropdownItem>
                                <DropdownItem key={3} onClick={() => changePageSize(25)}>۲۵</DropdownItem>
                                <DropdownItem key={4} onClick={() => changePageSize(50)}>۵۰</DropdownItem>
                                <DropdownItem key={5} onClick={() => changePageSize(100)}>۱۰۰</DropdownItem>
                                <DropdownItem key={6} onClick={() => changePageSize(1000000)}>همه</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>

                </div>
            </div>

            <div className="table-container">
                <table ref={myTable}>
                    <thead>
                    <tr>
                        <th key={0} onClick={() => sortTable(0)}
                            className="flaticon-sort-1">ردیف</th>
                        {tableHeaders.map((tableHeader, i) => {
                            if (tableColumns.includes(tableHeader)) {
                                return (
                                    <th key={i+1} onClick={() => sortTable(i+1)}>
                                        <i className="fa fa-sort mr-1" aria-hidden="true"/>
                                        {tableHeader}
                                    </th>
                                )
                            }
                        })}
                    </tr>
                    </thead>
                    <tbody ref={myTableBody}>
                    {searchedTableRow.slice(from, to).map((item, i) =>
                        <tr key={i}>
                            <td key={0}>{from + i + 1}</td>
                            {tableData.map((data, i) => {
                                if (!tableColumnsIndex.includes(i)) {
                                    return <td key={i+1}>{data(item)}</td>
                                }
                            })}
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
            <div className="table-footer">
            <div className="row">
                    <div className="col-md-4 d-flex col-12 justify-content-center align-items-center order-0" id="displayOptions">
                        <div className="search-sm d-inline-block mr-1 mb-1">
                            <input
                                autoComplete="off"
                                type="text"
                                name="keyword"
                                id="search"
                                placeholder="جست‌وجو در جدول"
                                onKeyPress={(e) => setTableSearchValue(toEnglishNumbers(e.target.value))}
                            />
                        </div>
                    </div>

                    <div className="col-md-4 col-12 d-flex flex-column justify-content-center align-items-center order-md-1 order-2">
                        <span>نمایش {from === 0 ? "۱" : from} تا {to > searchedTableRow.length ? searchedTableRow.length : to} از {searchedTableRow.length}</span>

                        {tableRowCount !== 1000000 ?
                            <Pagination className="d-inline-block" size="sm" listClassName="justify-content-center" aria-label="Page navigation example">
                                <PaginationItem className={`${selectedPage===0 && "disabled"}`}>
                                    <PaginationLink
                                        className={"prev"}
                                        onClick={() => { changePage("first") }}
                                        disabled={selectedPage===0}>
                                        اولین
                                    </PaginationLink>
                                </PaginationItem>
                                <PaginationItem className={`${selectedPage===0 && "disabled"}`}>
                                    <PaginationLink
                                        className={"prev"}
                                        onClick={() => { changePage("prev") }}
                                        disabled={selectedPage===0}>
                                        <i className="simple-icon-arrow-left" />
                                    </PaginationLink>
                                </PaginationItem>

                                {renderPages()}

                                <PaginationItem className={`${selectedPage===pageNumbers.length-1 && "disabled"}`}>
                                    <PaginationLink
                                        className="next"
                                        onClick={() => { changePage("next") }}
                                        disabled={selectedPage===pageNumbers.length-1}>
                                        <i className="simple-icon-arrow-right" />
                                    </PaginationLink>
                                </PaginationItem>
                                <PaginationItem className={`${selectedPage===pageNumbers.length-1 && "disabled"}`}>
                                    <PaginationLink
                                        className="next"
                                        onClick={() => { changePage("last") }}
                                        disabled={selectedPage===pageNumbers.length-1}>
                                        آخرین
                                    </PaginationLink>
                                </PaginationItem>
                            </Pagination>
                            :
                            <Pagination className="d-inline-block" size="sm" listClassName="justify-content-center" aria-label="Page navigation example">
                                <PaginationItem active={true}>
                                    <PaginationLink>
                                        ۱
                                    </PaginationLink>
                                </PaginationItem>
                            </Pagination>
                        }
                    </div>

                    <div className="col-md-4 d-flex col-12 justify-content-center align-items-center order-md-2 order-1 my-md-0 my-2" id="displayOptions">
                        <div className="mr-1">
                            تعداد سطر:
                        </div>
                        <UncontrolledDropdown className="d-inline-block dropdown">
                            <DropdownToggle caret color="outline-dark" size="xs">
                                {tableRowCount !== 1000000 ? tableRowCount : "همه"}
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem key={1} onClick={() => changePageSize(5)}>۵</DropdownItem>
                                <DropdownItem key={2} onClick={() => changePageSize(10)}>۱۰</DropdownItem>
                                <DropdownItem key={3} onClick={() => changePageSize(25)}>۲۵</DropdownItem>
                                <DropdownItem key={4} onClick={() => changePageSize(50)}>۵۰</DropdownItem>
                                <DropdownItem key={5} onClick={() => changePageSize(100)}>۱۰۰</DropdownItem>
                                <DropdownItem key={6} onClick={() => changePageSize(1000000)}>همه</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>

                </div>
            </div>

        </div>
    );
};

